import { render, staticRenderFns } from "./EntregaDetalheReprovacao.vue?vue&type=template&id=36568f4f"
import script from "./EntregaDetalheReprovacao.vue?vue&type=script&lang=js"
export * from "./EntregaDetalheReprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports